import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoldPayoutsModalComponent } from './hold-payouts-modal.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [HoldPayoutsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class HoldPayoutsModalModule {}
